/* @typescript-eslint/ban-ts-ignore */

import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const DataLayer: FC = () => {
  const { currentAccount } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    const customer = currentAccount?.customer;
    let partnershipId: string;
    if (!customer) {
      if (!currentAccount?.partnershipId) {
        return;
      }
      partnershipId = currentAccount.partnershipId;
    } else {
      partnershipId = customer?.sourcePartnershipId ?? '';
    }

    const customerId = customer?.id ?? '';
    const domain = window.location.hostname.split('.')?.[0];
    window.chooosePartnershipId = partnershipId;
    window.choooseCustomerId = customerId;

    if (!domain || domain === 'localhost') {
      return;
    }

    // @ts-ignore
    window.dataLayer.push({
      event: 'customer-data-loaded',
      env: domain.includes('-test') ? 'test' : 'production',
      domain: domain.replace('-test', ''),
      chooosePartnershipId: partnershipId,
      choooseCustomerId: customerId,
    });
  }, [currentAccount]);

  return null;
};

export default DataLayer;
